export default "__VITE_ASSET__xbc6roqz__"